// src/redux/slices/uploadPatientDocumentsDrawerSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { patients } from "lobbie";

export interface IUploadPatientDocumentsDrawerState {
    show: boolean;
    accountPatient?: patients.IAccountPatient | undefined;
    onDocumentAttach?: () => void;
}

export const initialStateUploadPatientDocumentsDrawer: IUploadPatientDocumentsDrawerState = {
    show: false,
    accountPatient: undefined,
};

const uploadPatientDocumentsDrawerSlice = createSlice({
    name: "uploadPatientDocumentsDrawer",
    initialState: initialStateUploadPatientDocumentsDrawer,
    reducers: {
        showUploadPatientDocumentsDrawer: (
            state,
            action: PayloadAction<Omit<IUploadPatientDocumentsDrawerState, "show">>,
        ) => {
            return {
                accountPatient: undefined,
                ...action.payload,
                show: true,
            };
        },
        hideUploadPatientDocumentsDrawer: () => initialStateUploadPatientDocumentsDrawer,
    },
});

export const { showUploadPatientDocumentsDrawer, hideUploadPatientDocumentsDrawer } =
    uploadPatientDocumentsDrawerSlice.actions;

export default uploadPatientDocumentsDrawerSlice.reducer;
